import { render, staticRenderFns } from "./DefectCheckListDetailsViewForm.vue?vue&type=template&id=cc6d0d7a"
import script from "./DefectCheckListDetailsViewForm.vue?vue&type=script&lang=js"
export * from "./DefectCheckListDetailsViewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports